<template>
    <c-dialog ref="dialog" width="700" mode="slide" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户代码" tip="请输入最多6位数字，不允许重复">
                <c-input type="number" name="saas_id" maxlength="6" :range="[1,999999]" :disabled="editState" placeholder="不输入,将自动生成"></c-input>
            </c-form-item>
            <c-form-item label="商户简码" required tip="请输入3个字符，只能输入数字或英文字母，输入英文字母将自动转换为大写，不允许重复">
                <c-input name="saas_brief_code" maxlength="3" placeholder="请输入商户简码"></c-input>
            </c-form-item>
            <c-form-item label="通联账户类型" required :tip="memberTypeTipWord">
                <c-radio-group name="allinpay_saas_type" :options="ALLINPAY_SAAS_TYPE" :clear="false"  v-model="allinpaySaasType"
                               :disabled="editState"></c-radio-group>
            </c-form-item>
            <c-form-item label="商户简称" required>
                <c-input name="saas_name" maxlength="50"></c-input>
            </c-form-item>
            <c-form-item label="商户名称" required>
                <c-input name="saas_full_name" maxlength="100"></c-input>
            </c-form-item>
            <c-form-item label="开通版本" required>
                <c-radio-group name="version_id" :options="versionOptions" :clear="false"
                               :disabled="editState"></c-radio-group>
            </c-form-item>
            <c-form-item label="授权开始时间" required>
                <c-datetime name="auth_start_date" type="datetime" format="yyyy-MM-dd"
                            :disabled="editState"></c-datetime>
            </c-form-item>
            <c-form-item label="授权到期时间" required>
                <c-datetime name="auth_exp_date" type="datetime" format="yyyy-MM-dd"
                            :disabled="editState"></c-datetime>
            </c-form-item>
            <c-form-item label="商户类型" required>
                <c-select name="merchant_type" :options="merchantTypeOptions"></c-select>
            </c-form-item>
            <c-form-item label="保证金下限金额" tip="保证金不足时不可上架、改价、提现及确认核销，下架和发货不受影响" required>
                <c-input name="deposit_min_amount" type="number" :decimal="2" :range="[0,999999999.99]" append-text="元"></c-input>
            </c-form-item>
            <c-form-item label="线下渠道收款形式" required>
                <c-select name="offline_payment_type" :options="offlinePaymentTypeOptions"></c-select>
            </c-form-item>
            <c-form-item label="商户联系人姓名" required>
                <c-input name="saas_contact_person" maxlength="20"></c-input>
            </c-form-item>
            <c-form-item label="商户联系电话" required>
                <c-input name="saas_contact_phone" maxlength="30"></c-input>
            </c-form-item>
            <c-form-item label="系统管理账号" tip="登录商家后台，默认使用“admin”">
                <c-input name="manage_user_name" maxlength="10" disabled></c-input>
            </c-form-item>
            <c-form-item label="系统管理员姓名" tip="登录商家后台展示的用户姓名，不填写则默认使用“系统管理员”">
                <c-input name="manage_user_realname" maxlength="10" :disabled="editState"></c-input>
            </c-form-item>
            <c-form-item label="系统管理员手机号"
                         tip="请输入11位手机号，该手机号将用于登陆商家后台系统,同时作为生成通联账户的唯一凭证，不允许重复" required>
                <c-input name="manage_user_phone" maxlength="11" :disabled="editState"></c-input>
            </c-form-item>
            <c-form-item label="营业执照照片" required v-show="allinpaySaasType != 3">
                <c-upload-file filePath="quote" name="business_license_img" type="image" size="1024" button="请选择图片" media v-model="business_license_img"></c-upload-file>
            </c-form-item>
            <c-form-item :label="allinpaySaasType ==3 ?'个人身份证正面照片':'法人身份证正面照片'" required>
                <c-upload-file filePath="quote" name="id_card_front_img" type="image" size="1024" button="请选择图片" media v-model="id_card_front_img"></c-upload-file>
            </c-form-item>
            <c-form-item :label="allinpaySaasType ==3 ?'个人身份证反面照片':'法人身份证反面照片'" required>
                <c-upload-file filePath="quote" name="id_card_back_img" type="image" size="1024" button="请选择图片" media v-model="id_card_back_img"></c-upload-file>
            </c-form-item>
            <c-form-item label="签约合同照片" required>
                <c-upload-file filePath="quote" name="contract_img" type="image" size="1024" button="请选择图片" media v-model="contract_img"></c-upload-file>
            </c-form-item>

            <c-form-item label="联系地址">
                <c-input name="saas_address" maxlength="200"></c-input>
            </c-form-item>
            <c-form-item label="最大用户数" tip="当前商户可创建的子账号数量">
                <c-input name="max_account_count" type="stepper" step-controls="side" range="1,500" append-text="个"
                         v-model="max_account_count" :clear="false" :disabled="editState"></c-input>
            </c-form-item>
            <c-form-item label="备注">
                <c-input type="textarea" name="remark"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

export default {
    data() {
        return {
            editState: false,
            allinpaySaasType:3,//类型 2=企业 ；3=个人；4=个体工商户
            versionOptions: [],//可选版本列表
            merchantTypeOptions: [//商家类型
                {name: '自营商户', value: 1, color: 'green'},
                {name: '普通商户', value: 2, color: 'blue'}
            ],
            offlinePaymentTypeOptions: [//线下渠道收款形式
                {name: '自主收款', value: 1, color: 'green'},
                {name: '分账', value: 2, color: 'blue'}
            ],
            max_account_count: 99,
            is_template: 2,
            business_license_img:'',
            id_card_front_img:'',
            id_card_back_img:'',
            contract_img:''
        }
    },
    computed: {
        memberTypeTipWord() {
            return {
                2: '只允许绑定对公账户，禁止绑定私人银行卡；需要工 商审核通过+法人实名通过+绑定手机号三重认证',
                3: '可绑定多张本人名下储蓄卡，资金出入户主体必须个实名认证自然人一致；需要实名核验通过+绑定手机号完成认证',
                4: '注册的通联账户同样为“企业”类型，需要完善企业相关信息'
            }[this.allinpaySaasType]
        },
        ...mapState(['saasInfo']),

        ...asyncMapState(['ALLINPAY_SAAS_TYPE'])
    },

    mounted() {
        this.initSaasVersion();
    },

    methods: {
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要+1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        /*******加载版本下拉框数据*****************/
        initSaasVersion(keyword, resolve) {
            this.request({
                url: '/sys_saas/version/list',
                data: {},
                success: data => {
                    this.versionOptions = data.map(item => {
                        return {
                            name: item.version_name,
                            value: item.id,
                            data: item
                        }
                    })
                }
            })
        },

        /*********打开编辑框，初始化**********/
        open(data) {
            this.editState = !!data;
            this.$refs.form.clear();
            if (data) {
                let saasData = Object.assign({},data, data.extra_info);
                this.$refs.form.set(saasData);
                this.max_account_count = data.max_account_count || 99;
                this.allinpaySaasType = data.allinpay_saas_type || 3;
            } else {
                const auth_start_date = this.formatDate(Date.now());
                this.$refs.form.set({
                    auth_start_date: auth_start_date,
                    manage_user_name: 'admin',
                    manage_user_realname: '系统管理员',
                    max_account_count: this.max_account_count
                });
            }
            //填充form表单
            this.$refs.dialog.open({
                title: data ? '编辑商户信息' : '创建商户信息'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: this.editState ? '/sys_saas/edit' : '/sys_saas/add',
                rule: {
                    allinpay_saas_type: '请选择通联账户类型',
                    saas_name: '请填写商户简称',
                    saas_full_name: '请填写商户名称',
                    saas_brief_code: '请填写商户简码',
                    version_id: '请选择开通版本',
                    auth_start_date: '请选择授权开始时间',
                    auth_exp_date: '请选择授权截止时间',
                    merchant_type: '请选择商户类型',
                    deposit_min_amount: '请填写保证金下限金额',
                    offline_payment_type: '请选择线下渠道收款形式',
                    saas_contact_person: '请填写商户联系人姓名',
                    saas_contact_phone: '请填写商户联系电话',
                    manage_user_phone: [{
                        type: 'empty',
                        message: '请填写商户系统管理员手机号'
                    }, {
                        type: 'regexp',
                        regexp: ['phone'],
                        message: '商户系统管理员手机号格式异常，请输入11位手机号'
                    }],
                    business_license_img: [{
                                type: 'empty',
                                message: '请上传营业执照照片',
                                skip: () => {
                                    return this.allinpaySaasType == 3;
                                }
                    }],
                    id_card_front_img: this.allinpaySaasType ==3 ?'请上传个人身份证正面照片':'请上传法人身份证正面照片',
                    id_card_back_img: this.allinpaySaasType ==3 ?'请上传个人身份证正面照片':'请上传法人身份证正面照片',
                    contract_img: '请上传签约合同照片'
                },
                dataFormatter: data => {
                    var extra_info = {};
                    extra_info.business_license_img = this.business_license_img;
                    extra_info.id_card_front_img = this.id_card_front_img;
                    extra_info.id_card_back_img = this.id_card_back_img;
                    extra_info.contract_img = this.contract_img;
                    data.extra_info = JSON.stringify(extra_info);
                    data.member_type = this.allinpaySaasType == 3?3:2;
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState) {
                        this.$message({
                            message: '编辑成功',  // 提示内容,
                            type: 'success'
                        });
                    } else {
                        // 确认弹窗
                        this.$confirm({
                            title: '操作成功提示',
                            cancelButton: false,
                            message: res,
                            resolve: () => {
                            }
                        })
                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
